import "./App.css";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import Generate from "./pages/Generate";
import Home from "./pages/Home";
import SignInPage from "./pages/SignIn";
import SignUpPage from "./pages/SignUp";
import { createTheme } from "./theme/index";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <Header>
          <Home />
        </Header>
      ),
    },
    {
      path: "generate",
      element: (
        <Header>
          <Generate />
        </Header>
      ),
    },
    {
      path: "signUp",
      element: <SignUpPage />,
    },
    {
      path: "signIn",
      element: <SignInPage />,
    },
    {
      path: "dashboard",
      element: (
        <Header>
          <Dashboard />
        </Header>
      ),
    },
  ]);

  const theme = createTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="app">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
}

export default App;
